var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { GASOLINE_MOVIE_MAP } from '@/gasolineMovies/constants/gasolineMovie';
class GasolineMoviesRepository {
    types = [];
    backgrounds = [];
    initGasolineMovies(types, backgrounds) {
        this.types = (types ?? [])
            // check that dict item contains property "type", e.g { type }
            .filter((movieType) => !!movieType.type)
            .map((movieType) => {
            const { label } = GASOLINE_MOVIE_MAP[movieType.type] ?? {};
            return {
                type: movieType.type,
                label,
            };
        });
        this.backgrounds = backgrounds;
    }
    isOnlyOneBackgroundType() {
        return this.backgrounds.length === 1;
    }
    getDefaultGasolineBackground() {
        return this.backgrounds[0];
    }
}
__decorate([
    observable
], GasolineMoviesRepository.prototype, "types", void 0);
__decorate([
    observable
], GasolineMoviesRepository.prototype, "backgrounds", void 0);
export const gasolineMoviesRepository = new GasolineMoviesRepository();
